import React, { createContext } from "react";
import useAuth from "./useAuth";
import { TADIG } from "../const/Roles";

const Context = createContext();

function AuthProvider({ children }) {
  const { signed, user, setUser, loading, handleLogin, handleLogout, mustChangePassword, setMustChangePassword } =
    useAuth();

  const userHasTadigRole =
    user?.roles?.some((role) => role.name === TADIG) || false;

  return (
    <Context.Provider
      value={{
        signed,
        user,
        setUser,
        loading,
        handleLogin,
        handleLogout,
        userHasTadigRole,
        mustChangePassword,
        setMustChangePassword,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export { Context, AuthProvider };
